import colors from '../../colors';
import sizes from '../../sizes';
import darkBase from './base';

const darkCompact = {
    ...darkBase,
    current: {
        default: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.current.text
        },
        hover: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.current.text
        },
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.current.text
        }
    },
    inactive: {
        default: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.transparent,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.inactive.text
        },
        hover: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.coolGray200,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.inactive.hoverText
        },
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: darkBase.inactive.focusText
        }
    },
    disabled: {
        container: {
            paddingBottom: 8,
            paddingTop: 0,
            paddingLeft: 4,
            paddingRight: 4,
            height: 28
        },
        text: darkBase.disabled.text
    },
    container: {
        borderBottomWidth: 1,
        borderBottomColor: colors.coolGray700,
        backgroundColor: colors.coolGray800,
        paddingTop: sizes.fixedSpacing.md,
        paddingLeft: sizes.fixedSpacing['3xl'],
        emptySpaceHeight: sizes.fixedSpacing['4xl'],
        marginBottom: sizes.fixedSpacing.lg,
        boxShadow: '-5px 5px 10px 0 rgba(0, 0, 0, 0.20);'
    },
    panel: {
        padding: `0 ${sizes.fixedSpacing['md']}px`
    }
};

export default darkCompact;
